import Vue from 'vue';
import Component from 'vue-class-component';
import EdHeaderOutSession from '@/core/components/ed-header-out-session/ed-header-out-session.vue';

@Component({
  components: {
    EdHeaderOutSession
  }
})
export default class PublicView extends Vue {

  get hasHeader(): boolean {
    return this.$store.state.AppStore.header.visible;
  }

}